module.exports = __webpack_public_path__ + "static/media/HomeOutcomeWorkforceAiReadiness.77079197.jpg";